import { FormattedMessage } from 'react-intl';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';

import useIntl from '../../../hooks/useIntl';
import messages from '../messages';

const OTHER_SEE_NOTES = 'Other - See Notes';

const AffordableWaitlistActionModal = ({
  open,
  handleClose,
  modalProps,
  ReactHookFormProps,
  reasons,
  extraFields = [],
}) => {
  const intl = useIntl();
  const { watch } = ReactHookFormProps;
  const selectedReasons = watch('reasons');
  const requireNote =
    Array.isArray(selectedReasons) && selectedReasons.includes(OTHER_SEE_NOTES);

  const fields = [
    ...extraFields,
    {
      variant: 'multiSelect',
      name: 'reasons',
      label: <FormattedMessage {...messages.reason} />,
      options: reasons.map((name) => ({ value: name, text: name })),
      rules: { required: true },
      GridProps: { xs: 12 },
    },
    {
      variant: 'text',
      name: 'note',
      label: <FormattedMessage {...messages.notes} />,
      placeholder: 'Start Typing...',
      rules: {
        required: requireNote,
        validate: (note) => {
          if (requireNote && !note) {
            return intl.formatMessage(messages.notesRequired);
          }
          if (note && note.trim().length > 255) {
            return intl.formatMessage(messages.limitReached255);
          }
          return true;
        },
      },
      InputProps: { multiline: true, minRows: 4, maxRows: 5 },
      GridProps: { xs: 12 },
    },
  ];

  return (
    <Modal open={open} onClose={handleClose} {...modalProps}>
      <Form ReactHookFormProps={ReactHookFormProps} fields={fields} />
    </Modal>
  );
};

export default AffordableWaitlistActionModal;
